import classNames from '@utils/classnames';
import React, { useId, useRef } from 'react';

import { controlClassName } from '../form/control';

export interface TextAreaProps {
  id?: string;
  value: string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onFocus?: () => void;
  onChange: (newValue: string) => void;
  isInvalid?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  rows?: number;
  cols?: number;
  params: string[];
}

export const TemplateTextArea: React.FC<TextAreaProps> = (props) => {
  const { id: _id, value, onBlur, onFocus, onChange, isInvalid, isDisabled, placeholder, rows, cols, params } = props;
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const handleClickParam = (param: string) => {
    onChange(`${value.slice(0, ref.current?.selectionStart)}{{${param}}}${value.slice(ref.current?.selectionEnd)}`);
  };

  const generatedId = useId();
  const id = _id ?? generatedId;
  return (
    <div>
      <div className="mb-2 flex flex-wrap gap-1.5">
        {params.map((p) => {
          return (
            <button
              type="button"
              className="rounded-md border border-border bg-surface px-2 py-0.5 font-mono text-xs text-fg-secondary transition-colors hover:bg-surface-hover hover:text-fg"
              key={`${id}-${p}`}
              onClick={(evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                handleClickParam(p);
              }}
            >{`{{${p}}}`}</button>
          );
        })}
      </div>

      <div>
        <textarea
          ref={ref}
          id={id}
          rows={rows}
          cols={cols}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          onChange={(evt) => onChange(evt.target.value)}
          className={classNames(
            controlClassName({ isInvalid, isDisabled, focusWithin: false }),
            'block h-auto px-2.5 py-2',
          )}
          disabled={isDisabled}
          autoComplete="off"
        />
      </div>
    </div>
  );
};
